<template>
  <div class="sectiontitle-root color-text-primary">
    <div class="maintitle-container">
      <div class="maintitle-container-title">
        <span class="text-h7">{{ title }}</span>
        <span v-if="titleDetail" class="titleDetail text-subtitle-1 color-text-secondary">({{titleDetail}})</span>
      </div>
      <trend-chip
        :trend="trend"
        :date="lastUpdate"
      />
    </div>
    <span v-if="subtitle" class="text-subtitle-2 mt-1 color-text-secondary">{{subtitle}}</span>
    <a v-if="showAction" class="action-link" @click="emitAction">
      {{ actionText }}
    </a>
  </div>
</template>

<script>
import TrendChip from '@/components/DashViews/Charts/TrendChip.vue'

export default {
  name: 'SectionTitle',
  components: {
    TrendChip,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    titleDetail: {
      type: String,
      required: false,
      default: '',
    },
    subtitle: {
      type: String,
      required: false,
      default: '',
    },
    showAction: {
      type: Boolean,
      required: false,
      default: false,
    },
    actionText: {
      type: String,
      required: false,
      default: 'Learn More',
    },
    trend: {
      type: Number,
      required: false,
      default: undefined,
    },
    lastUpdate: {
      type: Date,
      required: false,
      default: undefined,
    },
  },
  methods: {
    emitAction() {
      this.$emit('action')
    },
  },
}
</script>

<style scoped lang="scss">
@import '@/styles/material-dashboard/variables.scss';

.sectiontitle-root {
  display: flex;
  justify-content: start;
  align-items: baseline;
  gap: 2px;
  flex-direction: column;
  
  .maintitle-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 4px;

    .maintitle-container-title {
      display: flex;
      gap: 4px;
      justify-content: start;
      flex-wrap: wrap;
    }
  }

  p { 
    margin: 0;
  }
  .titleDetail {
    font-weight: 500;
  }
}
</style>